<template>
  <div class="chart-container" :class="classObject" :style="styleObject">
    <div class="chart-content" :class="className" :id="chartId" :style="styleObject"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    chartReady: {
      type: Boolean,
      default: false,
    },
    chartId: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: 'horizontal-chart',
    },
    withBorder: {
      type: Boolean,
      default: true,
    },
    styleObject: {
      type: Object,
    },
  },
  computed: {
    classObject() {
      return {
        'chart-ready': this.chartReady,
        'border-container': this.withBorder,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/var';
@import '../../assets/theme/_themes.scss';

.chart-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 10px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;

  &.border-container {
    border: 1px solid #4e575e;
    @include border_color('border-tab');
    &:hover {
      @include border_color('primary');
    }
  }

  .chart-content {
    // position: absolute;
    width: 100%;
    height: 400px;
    overflow: hidden;
    &.horizontal-chart {
      height: 400px;
    }
    &.vertical-chart {
      height: 700px;
    }
    &.profile-chart {
      height: 933px;
    }
    &.square-chart {
      width: 500px;
      height: 500px;
    }
    &.threed-chart {
      height: 500px;
    }
  }
}
</style>
